import { render, staticRenderFns } from "./VBNav.vue?vue&type=template&id=102b7d8c&"
import script from "./VBNav.vue?vue&type=script&lang=js&"
export * from "./VBNav.vue?vue&type=script&lang=js&"
import style0 from "./VBNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports